import About from "./About";
import Profile from "./Profile";
import { useDispatch } from "react-redux";
import { closeModal } from "../../features/globalModalSlice";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import UpdateProfile from "./UpdateProfile";

const Contents = () => {
  const { isOpen, side } = useSelector((state: RootState) => state.globalModal);
  const dispatch = useDispatch();

  return (
    <>
      <div
        className={`sm:w-full md:w-[350px] h-full bg-white absolute top-0 z-20 transition-all duration-300 ease-in-out ${
          isOpen && side === "left"
            ? "left-0"
            : "sm:-left-full md:-left-[350px]"
        }`}
      >
        <div className="w-full h-full p-6 relative">
          <div className="flex justify-end">
            <button className="text-lg" onClick={() => dispatch(closeModal())}>
              <i className="fa-solid fa-xmark text-violet-500"></i>
            </button>
          </div>
          <UpdateProfile />
          <About />
        </div>
      </div>
      <div
        className={`sm:w-full md:w-[350px] h-full bg-white absolute top-0 z-20 transition-all duration-300 ease-in-out ${
          isOpen && side === "right"
            ? "right-0"
            : "sm:-right-full md:-right-[350px]"
        }`}
      >
        <div className="w-full h-full p-6 relative">
          <div className="flex justify-end">
            <button className="text-lg" onClick={() => dispatch(closeModal())}>
              <i className="fa-solid fa-xmark text-violet-500"></i>
            </button>
          </div>
          <Profile />
        </div>
      </div>
    </>
  );
};

export default Contents;
